<template>
  <div class="registerExpired">
    <v-card class="py-8 px-10">
      <h3 class="mb-6 text-center">連結已失效</h3>
      <div class="information">
        <div>由於長時間沒有被驗證，該註冊連結已失效</div>
        <v-icon color="warning">fa-clock</v-icon>
        <v-btn block rounded color="pink" to="/register">重新註冊</v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.registerExpired {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    .v-icon {
      display: block;
      margin: 20px 0;
      font-size: 70px;
    }
    .information {
      text-align: center;
      & > div {
        font-size: 14px;
      }
    }
  }
}
</style>